var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconResolveCaseActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8088 7.021C15.3573 7.021 14.7592 7.011 14.0146 7.011C12.1987 7.011 10.7055 5.508 10.7055 3.675V0.459C10.7055 0.206 10.5036 0 10.253 0H4.96363C2.49517 0 0.5 2.026 0.5 4.509V15.284C0.5 17.889 2.59022 20 5.16958 20H13.0463C15.5058 20 17.5 17.987 17.5 15.502V7.471C17.5 7.217 17.299 7.012 17.0475 7.013C16.6247 7.016 16.1177 7.021 15.8088 7.021Z",
    fill: "#FAAA52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72731 15C7.65822 15 7.59344 14.9888 7.53299 14.9664C7.47253 14.9441 7.41639 14.906 7.36457 14.8523L5.13631 12.5436C5.04131 12.4452 4.99596 12.3177 5.00028 12.1611C5.0046 12.0045 5.05426 11.877 5.14926 11.7785C5.24427 11.6801 5.36518 11.6309 5.512 11.6309C5.65883 11.6309 5.77974 11.6801 5.87474 11.7785L7.72731 13.698L12.1191 9.14765C12.2141 9.04922 12.3371 9 12.4883 9C12.6394 9 12.7625 9.04922 12.8575 9.14765C12.9525 9.24609 13 9.3736 13 9.5302C13 9.6868 12.9525 9.81432 12.8575 9.91275L8.09005 14.8523C8.03823 14.906 7.98209 14.9441 7.92164 14.9664C7.86118 14.9888 7.7964 15 7.72731 15Z",
    fill: "#FFEFDE",
    stroke: "#FFEFDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0842 0.56737C12.7852 0.25637 12.2632 0.47037 12.2632 0.90137V3.53837C12.2632 4.64437 13.1742 5.55437 14.2802 5.55437C14.9772 5.56237 15.9452 5.56437 16.7672 5.56237C17.1882 5.56137 17.4022 5.05837 17.1102 4.75437C16.0552 3.65737 14.1662 1.69137 13.0842 0.56737Z",
    fill: "#FAAA52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconResolveCaseActive);
export default __webpack_public_path__ + "static/media/Icon.ResolveCaseActive.c421f70a582e3749ea92bd0b63efbbb4.svg";
export { ForwardRef as ReactComponent };